import { render } from "./ReportDeletor.vue?vue&type=template&id=3065daae&scoped=true"
import script from "./ReportDeletor.vue?vue&type=script&lang=js"
export * from "./ReportDeletor.vue?vue&type=script&lang=js"

import "./ReportDeletor.vue?vue&type=style&index=0&id=3065daae&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3065daae"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QSpinner});
